var map = {
	"./icon_documents.svg": "b12e",
	"./icon_error.svg": "361b",
	"./icon_ok.svg": "e5ad",
	"./icon_upload.svg": "9c8a",
	"./icon_warning.svg": "1518"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "3e20";